import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/auth/authentication/authentication.service';

@Component({
  standalone: false,
  selector: 'mtn-public-landing-page',
  templateUrl: './public-landing-page.component.html',
  styleUrls: ['./public-landing-page.component.scss']
})
export class PublicLandingPageComponent  implements OnInit {

  constructor(private authenticationService: AuthenticationService) {
    // This constructor is intentionally empty
    // The authentication service will handle the authentication logic
  }

  ngOnInit(): void {
              this.authenticationService.openAuth0AuthenticationDialog();
  }


}
